import { html, LitElement } from 'lit';

class IconTwitter extends LitElement {
  static properties = {
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    fillColor: {
      type: String,
      attribute: 'fill-color',
    },
  };

  constructor() {
    super();
    this.height = '24';
    this.width = '24';
    this.fillColor = '#ffffff';
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" fill="${this.fillColor}" width="${this.width}" height="${this.height}" viewBox="0 0 24 24">
        <path d="M 2.3671875 3 L 9.4628906 13.140625 L 2.7402344 21 L 5.3808594 21 L 10.644531 14.830078 L 14.960938 21 L 21.871094 21 L 14.449219 10.375 L 20.740234 3 L 18.140625 3 L 13.271484 8.6875 L 9.2988281 3 L 2.3671875 3 z M 6.2070312 5 L 8.2558594 5 L 18.033203 19 L 16.001953 19 L 6.2070312 5 z"/>
      </svg>
    `;
  }
}
customElements.define('tenable-icon-twitter', IconTwitter);
